export default "__VITE_ASSET__$v2CXkB9__"